import { FC, useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { useDispatch } from 'react-redux';

import { LayoutMain } from './Main';
import { LayoutNavbar } from './Navbar';
import SplashScreen from './SplashScreen';
import { detectDevice } from '../../utils';
import Routes from '../../routers/routes';
import { storeName } from '../../redux/models/layout.model';

import './styles.scss';

const Layout: FC = () => {
  const [waitAuthCheck, setWaitAuthCheck] = useState<boolean>(true);

  const dispatch = useDispatch()[storeName];

  useEffect(() => {
    setTimeout(() => {
      setWaitAuthCheck(false);
    }, 1000);

    const isMobile = detectDevice();
    if (isMobile) dispatch.setMobileDevice(true);
  }, []);

  if (waitAuthCheck) return <SplashScreen />;

  return (
    <div className="clik-inventory__layout">
      <LayoutNavbar />
      <LayoutMain>
        <ConfigProvider>
          <Routes />
        </ConfigProvider>
      </LayoutMain>
    </div>
  );
};

export default Layout;
